import styled from 'styled-components'

export const MainWrapper = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
`

export const Head = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 40px;
`

export const LevelRowContainer = styled.div.attrs({
  className: `row col-12 mx-0`
})`
  padding: 24px 12px;
`

export const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
`

export const ButtonAdd = styled.img`
  height: 40px;
  width: 40px;
  margin-bottom: 20px;

  &:hover {
    opacity: 0.7;
    cursor: pointer;
  };
`

export const File = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 10px;
`
